export default "__VITE_ASSET__DtvjexiK__"